import { useQueryClient } from '@tanstack/react-query';
import useReactQueryBaseKey from 'hooks/react-query/useReactQueryBaseKey/useReactQueryBaseKey';
import { useAxios } from 'hooks/utils';
import { includes } from 'lodash';
import { useCallback } from 'react';

export interface IEquipmentDevice {
  id: number;
  current_coupled_date: string;
  equipment_id: string;
  esn: string;
  last_uncoupled_date: string;
  manufacturer_model: string;
  manufacturer_name: string;
  organization_id: string;
  status: string;
}

export default function useEquipmentDevices() {
  const axios = useAxios();
  const baseQueryKey = useReactQueryBaseKey();
  const queryClient = useQueryClient();

  return useCallback(
    async (enabled: boolean): Promise<IEquipmentDevice[]> => {
      if (!enabled) {
        return [];
      }

      try {
        return await queryClient.fetchQuery({
          queryKey: [...baseQueryKey, 'equipment-devices', 'all'],

          queryFn: async () => {
            let url = 'devices';

            let allData: IEquipmentDevice[] = [];

            while (url) {
              const res = await axios.get(url);
              allData = allData.concat(res.data.data);
              if (includes(url, res.data.next)) {
                break;
              }
              url = res.data.next || null;
            }

            return allData;
          },
        });
      } catch (error) {
        return [];
      }
    },

    [queryClient, baseQueryKey, axios]
  );
}
